import { IUserEmailStatus } from 'components/authentication/components/authentication-slice';
import { jwtDecode } from 'jwt-decode';

type DecodedToken = {
  email?: string;
  [key: string]: any;
};

// Decode Token:
export const decodeToken = (token: string) => {
  const decodedJwt = jwtDecode<DecodedToken>(token);
  return decodedJwt;
};

export const isEmailExistInToken = (token: string | null | undefined): boolean => {
  if (!token) return false;

  try {
    const decodedToken = decodeToken(token);
    // Check if Email field exists and has a value
    return typeof decodedToken.email === 'string' && decodedToken.email.trim() !== '';
  } catch (error) {
    console.error('Error decoding authToken:', error);
    return false;
  }
};

export const isEmailVerified = (userEmailStatus: IUserEmailStatus): boolean => {
  if (!userEmailStatus?.email) return false;
  try {
    // Check if Email exists
    if (userEmailStatus?.email == null) return false;
    else if (!userEmailStatus?.emailConfirmed) return true; // Check if Email is verified

    return false;
  } catch (error) {
    console.error('Error decoding authToken:', error);
    return false;
  }
};

export const getEmailFromToken = (token: string): string => {
  try {
    const decodedToken = decodeToken(token);
    return decodedToken.email || '';
  } catch (error) {
    console.error('Error decoding JWT:', error);
    return '';
  }
};
